import axios from "axios";
import { PropertiesObj } from "../Models/PropertiesObj";

const Url = process.env.REACT_APP_URl;
const UrlDev = process.env.REACT_APP_URl;

// Listings

export const getListings = async (filterOptions: any, page: number) => {
  const response = await axios.post(UrlDev + "/listings", { "page": page, "perPage": 8, "filterOptions": filterOptions }, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  const properties: PropertiesObj = { total: response.data.total, properties: response.data.properties }
  return properties;
}

export const DropProperties = async (properties: any) => {
  const response = await axios.post(UrlDev + "/dlistings", properties, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const DropProperty = async (id: any) => {
  const response = await axios.delete(`${Url + "/listing"}/${id}`, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const UploadPropertiesXml = async (formData: any) => {
  const response = await axios.post(Url + "/propertiesxml", formData, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
};

export const getPropertiesById = async (id: number) => {
  const response = await axios.get(`${UrlDev + "/listing/"}${id}`, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const getProccessImages = async (processId: any) => {
  const response = await axios.get(`${UrlDev + "/getstastics/"}${processId}`, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}
export const RefreshProccesing = async (processId: any) => {
  const response = await axios.get(`${UrlDev + "/refrishstics/"}${processId}`, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const SharePropertyById = async (id: number) => {
  const response = await axios.get(`${UrlDev + "/sharelisting/"}${id}`)
  return response.data;
}

export const getLocations = async (locationName: any, co?: any) => {

  const response = await axios.post(Url + "/locations/autocomplete", { locationName: locationName, co: co }, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const getLocationsFind = async (location: any, co?: any) => {

  const response = await axios.post(Url + "/locations/find", { location: location }, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const GetFilters = async () => {
  const response = await axios.get(UrlDev + "/filters", {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const DownloadXmlProperties = async (platform: any) => {

  const response = await axios.post(UrlDev + "/downloadxml", { platform: platform }, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const DownloadXmlProperty = async (platform: any, idProperty: any) => {
  const response = await axios.post(UrlDev + "/downloadxmlforone", { platform: platform, id: idProperty }, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const PublishPropertiesServ = async (listings: any) => {
  const response = await axios.put(Url + "/publish", listings, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const DuplicatePropertiesServ = async (listings: any) => {
  const response = await axios.post(UrlDev + "/duplicate_listing", listings, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const getAgentListings = async (broker: any) => {

  const response = await axios.post(Url + "/properties/agent_listings_count", { "broker": broker }, {
    headers: {
      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const GetQRCodeService = async (id: any) => {
  const response = await axios.get(`${Url + "/propertytarkhis"}/${id}`, {
    headers: {      
      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  localStorage.setItem('curl', Url + "/propertytarkhis");
  return response.data;
}

export const getVersions = async (ref: any) => {
  const response = await axios.get(`${Url + "/properties"}/${ref}/${"versions"}`, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const UpdatePropertyService = async (property: any, id: any) => {
  const response = await axios.put(`${UrlDev}/${"listing"}/${id}`, property, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const AddListing = async (obj: any) => {
  const response = await axios.post(UrlDev + "/AddListing", obj, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}


export const SelectProperty = async () => {
  const apiUrl = Url + "/selectproperty";
  const response = await axios.get(apiUrl, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const propertieImages = async (id: any) => {
  const apiUrl = Url + "/propertieImages";
  const response = await axios.post(apiUrl, { "id": id }, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data;
}

export const SearchFilter = async (value: any) => {
  const apiUrl = Url + "/";
  const response = await axios.post(apiUrl, { value: value })
  return response.data
}

export const UploadTemplateServ = async (obj: any) => {
  const apiUrl = UrlDev + "/templates"
  const response = await axios.post(apiUrl, obj, {
    headers: {
      

      "Authorization": "Bearer " + localStorage.getItem("usertoken")
    }
  })
  return response.data
}

